import { createContext } from '@lit/context';
export const dividersContext = createContext('menu-dividers');
export const groupLabelsContext = createContext('menu-group-labels');
export const menuSizeContext = createContext('menu-size');
//# sourceMappingURL=menu-context.js.map